import request from '@/utils/request';
import { CartItem, CartParams } from '@/views/Cart/types';
const pre = '/portal/userShoppingCart';

// 加入购物车
export const addCart = (data: CartParams): Promise<IResponse> => {
  return request({
    url: `${pre}/addItem`,
    method: 'post',
    data,
  });
};

// 加入购物车
export const delCart = (cartItemId: string): Promise<IResponse> => {
  return request({
    url: `${pre}/delCartProductByItemId`,
    method: 'get',
    params: { cartItemId },
  });
};

// 获取购物车列表
export const getCartList = (sceneId: string | null): Promise<IResponse> => {
  return request({
    url: `${pre}/listItem`,
    params: { sceneId },
  });
};

// 更新购物车
export const updateCart = (data: CartItem): Promise<IResponse> => {
  return request({
    url: `${pre}/updateCartProductByItemId`,
    method: 'post',
    data,
  });
};

// 获取项目列表
export const getMyProjectList = (sceneId?: string): Promise<IResponse> => {
  return request({
    url: `/portal/project/page`,
    method: 'post',
    data: {
      queryOwn: true,
      pageNum: 1,
      pageSize: 9999,
      sceneId,
    },
  });
};

// 获取场景列表
export const getMySceneList = (): Promise<IResponse> => {
  return request({
    url: '/portal/scene/page',
    method: 'get',
    params: {
      queryOwn: true,
      pageNum: 1,
      pageSize: 9999,
      inPortal: true,
    },
  });
};

// 创建订单`
export const createOrder = (data: any[]): Promise<IResponse> => {
  return request({
    url: '/portal/userOrder/create',
    method: 'post',
    data,
  });
};

// 创建订单含合约
export const createOrderByContract = (data: any[]): Promise<IResponse> => {
  return request({
    url: '/portal/userOrder/createByContract',
    method: 'post',
    data,
  });
};

// 批量获取连接器注册跳转地址
export const getConnectorRegistryUrl = (
  entIds: string[],
): Promise<IResponse> => {
  return request({
    url: '/portal/userOrder/getConnectorRegistryUrl',
    method: 'post',
    data: entIds,
  });
};

export const getSsoTicket = (): Promise<IResponse> => {
  return request({
    url: '/getSsoTicket',
    method: 'get',
  });
};
